var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpicy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_552_547",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 14,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05532 5.53136C7.60466 3.66237 9.82966 2.8887 11.4197 4.01403C12.795 4.9867 13.0257 6.93603 11.9157 8.20303L10.8723 9.39436C9.13262 11.3805 6.93576 12.9135 4.47132 13.861L3.28532 14.3174C3.11149 14.384 2.91954 14.3862 2.7442 14.3237C2.56885 14.2611 2.42169 14.1379 2.32931 13.9762C2.23694 13.8146 2.20545 13.6252 2.24054 13.4424C2.27564 13.2596 2.375 13.0953 2.52066 12.9794L3.44732 12.2434C4.83561 11.1405 5.84908 9.63547 6.34899 7.93436L7.05532 5.53136Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94727 3.56149C10.0273 3.31853 10.163 3.0976 10.3434 2.9163C10.5239 2.73499 10.7441 2.5983 10.9867 2.51711C11.2293 2.43592 11.4875 2.41247 11.7407 2.44863C11.9939 2.48478 12.2352 2.57955 12.4454 2.72538C12.6556 2.8712 12.8288 3.06407 12.9513 3.28863C13.0738 3.5132 13.1422 3.76325 13.1511 4.0189C13.1599 4.27455 13.109 4.52874 13.0023 4.76124C12.8956 4.99374 12.7362 5.19813 12.5366 5.35815",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 1.3335L12.666 2.66683",
    stroke: "white",
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_552_547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "#FF4A32"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpicy);
export default __webpack_public_path__ + "static/media/Spicy.36e7d000ad00aee57e93f881ec6744b6.svg";
export { ForwardRef as ReactComponent };